module.exports = __webpack_public_path__ + "static/media/Credits-41.28bf08e4.pdf";